import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addGroupPermissionForSharee,
  addGroupPublicPermission,
  fetchGroupShareStatus,
  removeGroupPermissionForSharee,
  removeGroupPublicPermission,
  shareGroupPublicly,
  shareGroupWithEmail,
  unshareGroupPublicly,
  unshareGroupWithSharee,
} from '@actions/shareStatuses/groups';
import analytics from '@support/analytics';
import ShareResourceModal from './ShareResource';
import { selectActiveGroup } from '@actions/groupView';
import { selectGroupShareStatus } from '@reducers/data/shareStatuses/groups';
import { GroupPill } from '@components/Contact/Groups';

export default function ShareGroupModal({ closeModal }: { closeModal: () => void }) {
  const dispatch = useDispatch();
  const group = useSelector(selectActiveGroup); // return if null?
  const groupShareStatus = useSelector(selectGroupShareStatus(group?.id));

  useEffect(() => {
    if (group && !groupShareStatus.isLoaded) {
      dispatch(fetchGroupShareStatus(group.id));
    }
  }, []);

  useEffect(() => {
    analytics.track('Group Share Tapped');
  }, []);

  return (
    <ShareResourceModal
      closeModal={closeModal}
      sharedResourceType="group"
      shareStatus={groupShareStatus}
      sharedResourcePill={<GroupPill group={group} asLink={false} />}
      sharePublicly={() => dispatch(shareGroupPublicly(groupShareStatus))}
      unsharePublicly={() => dispatch(unshareGroupPublicly(groupShareStatus))}
      addPublicPermission={(permission) =>
        dispatch(addGroupPublicPermission(groupShareStatus, permission))
      }
      removePublicPermission={(permission) =>
        dispatch(removeGroupPublicPermission(groupShareStatus, permission))
      }
      shareWithEmail={(email) =>
        dispatch(shareGroupWithEmail({ sharedResourceID: group.id, email }))
      }
      unshareWithSharee={(sharee) =>
        dispatch(unshareGroupWithSharee({ sharedResourceID: group.id, sharee }))
      }
      addShareePermission={(sharee, permission) =>
        dispatch(addGroupPermissionForSharee({ sharedResourceID: group.id, sharee, permission }))
      }
      removeShareePermission={(sharee, permission) =>
        dispatch(removeGroupPermissionForSharee({ sharedResourceID: group.id, sharee, permission }))
      }
    />
  );
}
